import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { RegularSection } from '@/components/Layouts'

interface Content {
    title?: string
    text?: string
}

interface S3_blogopen_2Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_blogopen_2Props) => {
    const { content = {} } = props
    const { title, text } = content
    return (
        <RegularSection aria-label='S3_blogopen_2' >
            <Grid
                container
                spacing={4}
            >
                <Grid size={12}>
                    <Typography variant='h1'>{title}</Typography>
                </Grid>

                <Grid size={12}>
                    <Typography
                        variant='body1'
                        sx={{ whiteSpace: 'pre-line' }}
                    >
                        {text}
                    </Typography>
                </Grid>
            </Grid>
        </RegularSection>
    )
}

export default Index
